import React from 'react';
import { WorkflowDocumentPicker } from 'src/app/workflows/WorkflowDocumentPicker';
import { ResourceAttachmentDto } from 'src/api/FiretrolApiClient';
import { useDrawingDocumentOptions } from 'src/api/queries/drawings/useDrawingQueries';
import { useAttachDrawingDocument } from 'src/api/queries/drawings/useDrawingMutations';

export interface IDrawingDocumentPickerProps {
  jobId: number;
  onAttached: (attachment: ResourceAttachmentDto) => void;
}

export const DrawingDocumentPicker: React.FC<IDrawingDocumentPickerProps> = ({
  jobId,
  onAttached,
}) => {
  const { data } = useDrawingDocumentOptions(jobId);
  const attach = useAttachDrawingDocument();

  return (
    <WorkflowDocumentPicker
      jobId={jobId}
      onAttached={onAttached}
      options={data ?? []}
      attachFromDocument={(id, documentId) =>
        attach.mutateAsync({ jobId: id, documentId })
      }
      attaching={attach.isPending}
    />
  );
};
